import convertKeys from 'utils/convert-keys'
import { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'

import { ENDPOINTS } from './constants'

const deleteYodleeAccount = async (accountId) => {
  const token = await getToken()

  return cognitoAxiosInstance(token).delete(`${ENDPOINTS.YODLEE_ACCOUNTS}/${accountId}`)
}

const fetchYodleeAccounts = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(ENDPOINTS.YODLEE_ACCOUNTS)
  return convertKeys.toCamel(data)
}

export const fetchYodleeFastLinkParams = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(ENDPOINTS.YODLEE_FASTLINK_PARAMS)
  return convertKeys.toCamel(data)
}

const fetchShoppingRewardsStatistics = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(ENDPOINTS.SHOPPING_REWARDS_STATISTICS)
  return convertKeys.toCamel(data)
}

export default {
  deleteYodleeAccount,
  fetchYodleeAccounts,
  fetchYodleeFastLinkParams,
  fetchShoppingRewardsStatistics,
}
